import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import Logo from 'src/assets/images/common/logo-slo.svg';
import MainLogo from 'src/assets/images/logo_new.svg';
import ConnectingLoader from 'src/assets/images/common/connecting.svg';
import AmazonLogo from 'src/assets/images/common/amazon.svg';
import { useLocation } from 'react-router-dom'
import chartloader from 'src/assets/images/common/chart-loader.svg';
import Navigation from './Navigation';
import NavBar from './NavBar';
import Breadcrumb from './Breadcrumb';

import useWindowSize from '../../hooks/useWindowSize';
import useOutsideClick from '../../hooks/useOutsideClick';
import { ConfigContext } from '../../contexts/ConfigContext';
import * as actionType from '../../store/actions';

import queryString from 'query-string';
import useApi from 'src/hooks/useApi';
import services from 'src/api/service';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useHistory } from 'react-router-dom';
import Styles from 'src/components/themeStyle';
import { ThemeContext, ThemeProvider } from 'src/providers/themeProvider';
import { Minimize } from 'react-feather';
import useZoom from 'src/hooks/useZoom';
import { useCookies } from 'react-cookie';
import { differenceInDays, isDate } from 'date-fns';
import moment from 'moment-timezone';
import { dataEncrypt } from 'src/api/identity';
import { useAmzContext } from 'src/contexts/AmzContext';
import { useFkContext } from 'src/contexts/FkContext';
import { useInstaMartContext } from 'src/contexts/InstamartContext';
import { useBillingContext } from 'src/contexts/BillingContext';
import { useCommonContext } from 'src/contexts/CommonContext';
import useMixPanelTracker from 'src/hooks/useMixPanelTracker';
import useHeapTracker from 'src/hooks/useHeapTracker'
import { useMyntraContext } from 'src/contexts/MyntraContext';
import { useBlinkitContext } from 'src/contexts/BlinkitContext';
import Footer from './Footer';
import { COUNTRIES } from 'src/config/constant';
// import SupportIntercom from './Intercom';
import { useZeptoContext } from 'src/contexts/ZeptoContext';
import { useBigbasketContext } from 'src/contexts/BigbasketContext';
import useSupportTracker from 'src/hooks/useSupportTracker';
import usePylonChat from 'src/hooks/usePylonChat';
import BCGTextualAlert from '../../components/BCGTextual/bcg-textual-alert-popup';
import MobileTabletIncompatible from '../../components/MobileTabletIncompatible';

export const StyleTag = () => {
  const [themeMode, setTheme] = useContext(ThemeContext);
  console.log(themeMode.theme);
  return (
    <div>
      <style>{Styles(themeMode.theme)}</style>
    </div>
  );
};

const isPaymentAlert = 0

const AdminLayout = ({ children }) => {

  const zoom = useZoom();
  const analyticsRef = useMixPanelTracker()
  // const supportRef = useSupportTracker()
  const pylonRef = usePylonChat()
  // const heapTracking = useHeapTracker()
  const [cookies, setCookie, removeCookie] = useCookies();
  const {commonState, commonDispatch} = useCommonContext()
  const { amzState, amzDispatch } = useAmzContext()

  const { fkState, fkDispatch } = useFkContext()
  const { instamartState, instamartDispatch} = useInstaMartContext()
  const { myntraState, myntraDispatch } = useMyntraContext()
  const { blinkitState, blinkitDispatch } = useBlinkitContext()
  const { billingDispatch } = useBillingContext()
  const { zeptoState, zeptoDispatch } = useZeptoContext()
  const { bigbasketState, bigbasketDispatch } = useBigbasketContext()
  const isFlipKart = window.location.href.indexOf('account-settings') > -1;

  const location = useLocation();

  const ParseData = JSON.parse(localStorage.getItem('User'));

  const isSuperAdmin = useMemo(() => {
    return String(process.env.REACT_APP_ADMIN_ACCESS_EMAIL || '').indexOf(ParseData?.email) > -1;
  }, [])

 const selectedLocalCountry = useMemo(() => {
  return JSON.parse(localStorage.getItem('selectedCountry')) || COUNTRIES?.[0]
 }, []);

  const [listTotalCount, setListTotalCount] = useState(0);

  const [isAppReady, setIsAppReady] = useState(window.location.href.indexOf('amazon-dsp-request/create') > -1 || window.location.href.indexOf('amazon-audience-instance/create') > -1 ? true : window.location.href.indexOf('amazon') > -1 || window.location.href.indexOf('flipkart') > -1 || window.location.href.indexOf('myntra') > -1 || window.location.href.indexOf('blinkit') > -1 || window.location.href.indexOf('instamart') > -1 || window.location.href.indexOf('zepto') > -1 || window.location.href.indexOf('bigbasket') > -1  ? false : true);

  const queryParams = queryString.parse(window.location.search);
  const { code, scope } = queryParams;
  const { spapi_oauth_code, state, selling_partner_id } = queryParams;
  const isAMS = code && scope ? true : false;
  const isSeller = spapi_oauth_code && state && selling_partner_id ? true : false;

  const doAMSQueryParam = useApi(services.postService);
  const doAmsReAuthorize = useApi(services.postService);
  const doAMSProfiles = useApi(services.postService);
  const doSellerQueryparam = useApi(services.postService);
  const doSellerProfiles = useApi(services.postService);
  const doGetProfiles = useApi(services.postService);
  const doGetFlipkartProfiles = useApi(services.getService);
  const doGetMyntraProfiles = useApi(services.getService);
  const doGetBlinkitProfiles = useApi(services.getService);
  const doGetInstamartProfiles = useApi(services.getService);
  const doGetZeptoProfiles = useApi(services.getService);
  const doGetBigbasketProfiles = useApi(services.getService);
  const windowSize = useWindowSize();
  const ref = useRef();
  const configContext = useContext(ConfigContext);

  const [activeProfiles, setActiveProfiles] = useState([]);
  const [inActiveProfiles, setInActiveProfiles] = useState([]);
  const [screenLoader, setScreenLoader] = useState(false);

  const { collapseMenu, layout, subLayout, headerFixedLayout, configBlock } = configContext.state;
  const { dispatch } = configContext;
  const [isExit, setExitActive] = useState(false);
  const [exitOverlay, setexitOverlay] = useState(false);
  const urlPaths = {
    dayparting: window.location.href.indexOf('amazon-dayparting') > -1,
    chatgpt: window.location.href.indexOf('amazon-chatgpt') > -1,
    hector_registration: window.location.href.indexOf('hector-registrations') > -1,
    rulescreation: window.location.href.indexOf('amazon-automated-rules') > -1,
    usertimespend: window.location.href.indexOf('user-activity/time-spend-dashboard') > -1,
  };
  const pcodedContentElement = document.querySelector('.pcoded-content');
  const pcodedMainContentElement = document.querySelector('.pcoded-main-container');

  if ((urlPaths.dayparting || urlPaths.chatgpt || urlPaths.hector_registration || urlPaths.usertimespend) && pcodedContentElement) {
      pcodedContentElement.classList.add('px-3');
  } else if (pcodedContentElement) {
      pcodedContentElement.classList.remove('px-3');
  }

  if (pcodedContentElement) {
    if (urlPaths.chatgpt || urlPaths.usertimespend) {
        pcodedContentElement.classList.add('p-0');
    } else {
        pcodedContentElement.classList.remove('p-0');
    }
  }

  if (pcodedContentElement) {
    if (window.location.href.indexOf('amazon/campaign-drafts/auto/create') > -1) {
      pcodedContentElement.classList.add('pr-0');
  } else {
      pcodedContentElement.classList.remove('pr-0');
  }
  }

  if (pcodedMainContentElement) {
      if (urlPaths.chatgpt || urlPaths.rulescreation) {
          pcodedMainContentElement.classList.add('pt-0');
      } else {
          pcodedMainContentElement.classList.remove('pt-0');
      }
  }

  if ((urlPaths.rulescreation) && pcodedContentElement) {
    pcodedContentElement.classList.add('p-3');
  } else if (pcodedContentElement) {
      pcodedContentElement.classList.remove('p-3');
  }

  let history = useHistory();

  const getCurrentPlanDetails = useApi(services.getService);
  const getDateAvailableParams = useApi(services.getService);
  const getSqpDateAvailableParams = useApi(services.getService);

  const [profileDictionary, setProfileDictionary] = useState(
    window.location.href.indexOf('/flipkart') > -1
      ? JSON.parse(sessionStorage.getItem('flipkartProfile'))
      : window.location.href.indexOf('myntra') > -1
      ? JSON.parse(sessionStorage.getItem('myntraProfile'))
      : window.location.href.indexOf('/blinkit') > -1
      ? JSON.parse(sessionStorage.getItem('blinkitProfile'))
      : window.location.href.indexOf('zepto') > -1
      ? JSON.parse(sessionStorage.getItem('zeptoProfile'))
      : window.location.href.indexOf('bigbasket') > -1
      ? JSON.parse(sessionStorage.getItem('bigbasketProfile'))
      : JSON.parse(sessionStorage.getItem('selectedProfileId'))
  );

  const isFlipkart = window.location.href.indexOf('/flipkart') > -1;
  console.log(isFlipkart , 'isFlipkart')

  const useLocalStoreParam = useMemo(() => {
    return window.location.href.indexOf('flipkart') > -1
    ? 'flipkartStore'
    : window.location.href.indexOf('myntra') > -1 
    ? 'myntraStore'
    : window.location.href.indexOf('blinkit') > -1 
    ? 'blinkitStore'
    : window.location.href.indexOf('instamart') > -1
    ? 'instamartStore'
     : window.location.href.indexOf('zepto') > -1 
    ? 'zeptoStore'
     : window.location.href.indexOf('bigbasket') > -1 
    ? 'bigbasketStore'
    : 'amazonStore'
  }, [window.location.href])

  const useLocalStoreData = useMemo(() => {
    return JSON.parse(localStorage.getItem(useLocalStoreParam)) || []
  }, [useLocalStoreParam])

  const [flipkartProfiles, setFlipkartProfiles] = useState([]);
  const [myntraProfiles, setMyntraProfiles] = useState([]);
  const [blinkitProfiles, setBlinkitProfiles] = useState([]);
  const [instamartProfiles,setInstamartProfiles] = useState([]);
  const [zeptoProfiles, setZeptoProfiles] = useState([]);
  const [bigbasketProfiles, setBigbasketProfiles] = useState([]);
  

  useOutsideClick(ref, () => {
    if (collapseMenu) {
      setTimeout(() => {
        dispatch({ type: actionType.COLLAPSE_MENU });
      }, 3000);
    }
  });


  useEffect(() => {
    if ((useLocalStoreData && Array.isArray(useLocalStoreData) && useLocalStoreData.length == 0) || (!useLocalStoreData)) {
      console.log("useLocalStoreData1", useLocalStoreData)
      if (window.location.href.indexOf('amazon') > -1) {
        doGetProfiles.request({ url: isSuperAdmin ? '/profiles/mdb-get-ams-profiles' : '/profiles/mdb-get-profiles', nodeAPI: 1, payload: { active: true, ...(isSuperAdmin ? {
          page: 1,
          limit: 20,
          countryCode: selectedLocalCountry?.country_code
        } : {})} });
      } else if (window.location.href.indexOf('flipkart') > -1) {
        doGetFlipkartProfiles.request({ url: '/flipkart/clientList', nodeAPI: 1 });
      } else if (window.location.href.indexOf('myntra') > -1) {
        doGetMyntraProfiles.request({ url: '/myntra/clientList', nodeAPI: 1 });
      } else if (window.location.href.indexOf('blinkit') > -1) {
        doGetBlinkitProfiles.request({ url: '/blinkit/clientList', nodeAPI: 1 });
      } else if (window.location.href.indexOf('instamart') > -1) {
        doGetInstamartProfiles.request({ url: '/instamart/clientList', nodeAPI: 1 });
      } else if (window.location.href.indexOf('zepto') > -1) {
        doGetZeptoProfiles.request({ url: '/zepto/clientList', nodeAPI: 1 });
      } else if (window.location.href.indexOf('bigbasket') > -1) {
        doGetBigbasketProfiles.request({ url: '/bigbasket/clientList', nodeAPI: 1 });
      } 
    }
  }, [useLocalStoreData, window.location.href]);

  const platformMap = useMemo(() => {
    return {
      flipkart: {
        apiCall: doGetFlipkartProfiles,
        localProfileKey: 'flipkartProfile',
        localProfilesKey: 'flipkartProfiles',
        stateSetter: setFlipkartProfiles,
        dispatcher: fkDispatch,
        actionType: 'UPDATE_FLIPKART_PROFILES',
      },
      instamart: {
        apiCall: doGetInstamartProfiles,
        localProfileKey: 'instamartProfile',
        localProfilesKey: 'instamartProfiles',
        stateSetter: setInstamartProfiles,
        dispatcher: instamartDispatch,
        actionType: 'UPDATE_INSTAMART_PROFILES',
      },
      myntra: {
        apiCall: doGetMyntraProfiles,
        localProfileKey: 'myntraProfile',
        localProfilesKey: 'myntraProfiles',
        stateSetter: setMyntraProfiles,
        dispatcher: myntraDispatch,
        actionType: 'UPDATE_MYNTRA_PROFILES',
      },
      blinkit: {
        apiCall: doGetBlinkitProfiles,
        localProfileKey: 'blinkitProfile',
        localProfilesKey: 'blinkitProfiles',
        stateSetter: setBlinkitProfiles,
        dispatcher: blinkitDispatch,
        actionType: 'UPDATE_BLINKIT_PROFILES',
      },
      amazon: {
        apiCall: doGetProfiles,
        localProfileKey: 'selectedProfileId',
        localProfilesKey: 'active-profiles-ids',
        stateSetter: setActiveProfiles,
        dispatcher: amzDispatch,
        actionType: 'UPDATE_AMAZON_ACTIVE_PROFILES',
        defaultPayload: {
          active: true
        }
      },
      zepto: {
        apiCall: doGetZeptoProfiles,
        localProfileKey: 'zeptoProfile',
        localProfilesKey: 'zeptoProfiles',
        stateSetter: setZeptoProfiles,
        dispatcher: zeptoDispatch,
        actionType: 'UPDATE_ZEPTO_PROFILES',
      },
      bigbasket: {
        apiCall: doGetBigbasketProfiles,
        localProfileKey: 'bigbasketProfile',
        localProfilesKey: 'bigbasketProfiles',
        stateSetter: setBigbasketProfiles,
        dispatcher: bigbasketDispatch,
        actionType: 'UPDATE_BIGBASKET_PROFILES',
      },
    }
  }, [fkDispatch, instamartDispatch, myntraDispatch, blinkitDispatch, amzDispatch, doGetProfiles, doGetFlipkartProfiles, doGetMyntraProfiles, doGetBlinkitProfiles, doGetInstamartProfiles, window.location.href, useLocalStoreData, useLocalStoreParam, setActiveProfiles, setFlipkartProfiles, setMyntraProfiles, setBlinkitProfiles, setInstamartProfiles, doGetZeptoProfiles, setZeptoProfiles, zeptoDispatch, doGetBigbasketProfiles, setBigbasketProfiles, bigbasketDispatch]);
  
  const platformKey = useMemo(() => {
    return useLocalStoreParam?.replace('Store', '').toLowerCase()
  }, [useLocalStoreParam]);

  const platformData = useMemo(() => {
    return platformMap?.[platformKey]
  }, [platformMap, platformKey]);

  useEffect(() => {
    doProceeedLoad()
  }, [
    JSON.stringify(platformData), 
    platformData?.apiCall?.loading, 
    useLocalStoreData, 
    doGetProfiles.loading,
    doGetFlipkartProfiles.loading,
    doGetMyntraProfiles.loading,
    doGetBlinkitProfiles.loading,
    doGetInstamartProfiles.loading,
    doGetZeptoProfiles.loading,
    doGetBigbasketProfiles.loading
  ])


  const doProceeedLoad = useCallback(() => {
    console.log("doProceeedLoadData", platformData)
    if (platformData) {
      console.log("doProceeedloading", platformData?.apiCall)
      const { apiCall, localProfileKey, localProfilesKey, stateSetter, dispatcher, actionType } = platformData;
      console.log("useLocalStoreData", useLocalStoreData);
      if(useLocalStoreData && useLocalStoreData.length === 0) {
        const { loading, data } = apiCall;
        const listData = data?.data?.result || data?.data || []
        const listDataCount = data?.data?.totalCount || data?.data?.length || 0
        setListTotalCount(listDataCount)
        if (!loading && data && (data?.status === true || data?.success === true) && Array.isArray(listData)) {
          const profileData = listData.map((rowItem) => ({
            countryCode: rowItem?.countryCode || 'IN',
            currencyCode: rowItem?.currencyCode || 'INR',
            timezone: rowItem?.timezone || 'Asia/Kolkata',
            profileId: rowItem.profileId,
            accessLevel: rowItem.accessLevel || 'Admin',
            profileOwner: rowItem.profileOwner || ParseData?.email,
            ...rowItem,
            accountInfo: {
              type: 'advertising',
              ...rowItem?.accountInfo,
              name: rowItem?.accountInfo?.name || rowItem.Lable,
            },
          }));
          const dspAccountData = data?.dspAccounts?.map((dspItem)=>({
            ...dspItem,
          amazonManaged:dspItem?.amazonManaged,
          countryCode: dspItem?.countryCode || 'IN',
          currencyCode: dspItem?.currencyCode || 'INR',
          timezone: dspItem?.timezone || 'Asia/Kolkata',
          dspClientName: dspItem.dspClientName,
          accountInfo:{
            id: dspItem.dspId,
            name: dspItem.dspClientName,
            type:'DSP'
          },
          datasetId: dspItem.dspdatasetId,
          displayTypeTitle: 'DSP',
          profileId: dspItem?.agencyProfileId,
          profileOwner:dspItem.clientEmail,
          accessLevel: dspItem?.accessLevel || 'Admin',
          dsp_only: true,
          marketplace: `${CurrencyCodeMarketPlace[dspItem?.currencyCode || 'INR'] || 'europe'}`,
          dsp: [dspItem]
          })) || []
          const pendingDspAccountData = data?.dspPendingAccounts?.map((dspItem)=>({
            ...dspItem,
            countryCode: dspItem?.countryCode || 'IN',
            currencyCode: dspItem?.currencyCode || 'INR',
            timezone: dspItem?.timezone || 'Asia/Kolkata',
            dspClientName: dspItem?.dspClientName,
            displayTypeTitle: 'DSP',
            profileOwner:dspItem.clientEmail,
            accessLevel: dspItem?.accessLevel || 'Admin',
            dsp_only: true,
            dsp: [dspItem],
            accountInfo:{
              name: dspItem.dspClientName,
              type:'DSP'
            },
            isDspPendingRequest: true,
          })) || []
          const mdbData = [...profileData, ...dspAccountData, ...pendingDspAccountData]
          doUpdateProfile({profileData: mdbData, localProfileKey, localProfilesKey, stateSetter, dispatcher, actionType});
        }
         else {
          doUpdateProfile({profileData: [], localProfileKey, localProfilesKey, stateSetter, dispatcher, actionType});
        }
      } else {
        doUpdateProfile({profileData: useLocalStoreData, localProfileKey, localProfilesKey, stateSetter, dispatcher, actionType});
      }
    }
  }, [JSON.stringify(platformData), useLocalStoreData]);

  const doUpdateProfile = useCallback(({profileData, localProfileKey, localProfilesKey, stateSetter, dispatcher, actionType}) => {
    console.log("doUpdateProfile", profileData, localProfileKey, localProfilesKey, stateSetter, dispatcher, actionType)
    if (profileData && profileData.length > 0) {
      setIsAppReady(false)
      setTimeout(() => {

        const onboardedAgencyProfiles = JSON.parse(localStorage.getItem('OnBoardedAgencyProfiles'));
        // If onboarded agency profiles are present, then preselect the profile
        if (onboardedAgencyProfiles && onboardedAgencyProfiles?.length > 0) {
          const preselectedProfile = profileData.find(
            (profile) => onboardedAgencyProfiles.includes(profile?.profileId)
          );
          
          // If preselected profile is found, then set it as the current profile
          // If not found, then continue with the normal flow
          if (preselectedProfile) {
            sessionStorage.setItem(localProfileKey, JSON.stringify(preselectedProfile));
            localStorage.removeItem('OnBoardedAgencyProfiles');

            stateSetter(profileData);
            localStorage.setItem(useLocalStoreParam, JSON.stringify(profileData));
            // localStorage.setItem(localProfilesKey, JSON.stringify(profileData));
            dispatcher({ type: actionType, payload: profileData });
            setIsAppReady(true);
            return;
          }
        }

        const currentProfile = JSON.parse(sessionStorage.getItem(localProfileKey));
        if (currentProfile?.profileId || currentProfile?.dspId) {
          const selectedProfile = profileData.find((profile) => {
              const isNotDspOnly = !currentProfile?.dsp_only;

              const isMatchingProfile = isNotDspOnly &&
                  profile?.profileId == currentProfile?.profileId &&
                  profile?.accessLevel === currentProfile?.accessLevel &&
                  profile?.accountInfo?.type === currentProfile?.accountInfo?.type &&
                  profile?.profileOwner === currentProfile?.profileOwner;


              const isAgencyProfile = currentProfile?.type === 'Agency' &&
                  profile?.profileId == currentProfile?.profileId &&
                  profile?.accessLevel === currentProfile?.accessLevel &&
                  profile?.accountInfo?.type === currentProfile?.accountInfo?.type &&
                  profile?.profileOwner === currentProfile?.profileOwner;

              const isDspMatch = currentProfile?.dsp_only === true && 'dspId' in  profile && profile?.dspId === currentProfile?.dspId;

              return isMatchingProfile || isAgencyProfile || isDspMatch;
          });
          let profileDetails = isSuperAdmin ? currentProfile : selectedProfile ? selectedProfile : profileData[0]
          if (profileDetails?.dsp_only && ((currentProfile?.newDsp || []).length > 0 || currentProfile?.dsp?.[1]) && location.pathname.indexOf('/amazon-dsp') > -1) {
            profileDetails = { ...profileDetails, dsp: [...(profileDetails?.dsp || []), ...(currentProfile?.newDsp || [])] };
          }
          console.log("profileDetails", {profileDetails, currentProfile, selectedProfile, profileData})
          sessionStorage.setItem(localProfileKey, JSON.stringify(profileDetails));
          if(localProfileKey === 'selectedProfileId' && profileDetails && profileDetails?.ams?.groupedAccounts?.length > 0) {
            const groupedProfiles = [  ...[profileDetails] ,...profileDetails?.ams?.groupedAccounts]
            const selectedGroupProfileId = JSON.parse(sessionStorage.getItem('selectedGroupedProfileId'))
            if(selectedGroupProfileId && groupedProfiles.some((item) => item?.profileId === selectedGroupProfileId?.profileId)) {
              sessionStorage.setItem('selectedGroupedProfileId', JSON.stringify(groupedProfiles.find((item) => item?.profileId == selectedGroupProfileId?.profileId)))
            } else {
              sessionStorage.setItem('selectedGroupedProfileId', JSON.stringify(profileDetails))
            }
          } else {
            sessionStorage.setItem('selectedGroupedProfileId', JSON.stringify({}))
          }
        } else {
          const profileDetails = profileData?.[0]
          sessionStorage.setItem(localProfileKey, JSON.stringify(profileDetails));
          if(localProfileKey === 'selectedProfileId' && profileDetails && profileDetails?.ams?.groupedAccounts?.length > 0) {
            const groupedProfiles = [  ...[profileDetails] ,...profileDetails?.ams?.groupedAccounts]
            const selectedGroupProfileId = JSON.parse(sessionStorage.getItem('selectedGroupedProfileId'))
            if(selectedGroupProfileId && groupedProfiles.some((item) => item?.profileId === selectedGroupProfileId?.profileId)) {
              sessionStorage.setItem('selectedGroupedProfileId', JSON.stringify(groupedProfiles.find((item) => item?.profileId == selectedGroupProfileId?.profileId)))
            } else {
              sessionStorage.setItem('selectedGroupedProfileId', JSON.stringify(profileDetails))
            }
          } else {
            sessionStorage.setItem('selectedGroupedProfileId', JSON.stringify({}))
          }
        }
        stateSetter(profileData);
        localStorage.setItem(useLocalStoreParam, JSON.stringify(profileData));
        // localStorage.setItem(localProfilesKey, JSON.stringify(profileData));
        dispatcher({ type: actionType, payload: profileData });
        setIsAppReady(true);
      }, 1000)
    } else {
      setIsAppReady(false)
      stateSetter([]);
      sessionStorage.setItem(localProfileKey, JSON.stringify({}));
      // localStorage.setItem(localProfilesKey, JSON.stringify([]));
      dispatcher({ type: actionType, payload: [] });
      setTimeout(() => {
        setIsAppReady(true);
      }, 1000)
      localStorage.setItem(useLocalStoreParam, JSON.stringify([]));
    }
  }, [useLocalStoreParam])


  const [currentPlan, setCurrentPlan] = useState({});
  const [doGetUserDetailLoading, setDoGetUserDetailLoading] = useState(false);
  const getUserDetailsAbortControllerRef = useRef(null);

  useEffect(() => {
    // Cancel any previous request if it exists
    if (getUserDetailsAbortControllerRef.current) {
      getUserDetailsAbortControllerRef.current.abort();
      getUserDetailsAbortControllerRef.current = null;
    }

    // Create a new AbortController for this request
    const abortController = new AbortController();
    getUserDetailsAbortControllerRef.current = abortController;

    setDoGetUserDetailLoading(true);

    services.getService({
      url: '/auth/get-user-details',
      signal: abortController.signal
    }).then((res) => {
      // Only process response if request wasn't cancelled
      if (abortController.signal.aborted) {
        return;
      }

      const response = res?.data;
      console.log("get-user-details response", response)
      if(response && response?.success == true) {
        let localUserData = JSON.parse(localStorage.getItem('User'));
        let updatedUserData = { ...localUserData, ...response?.userDetails, journeyDetails: {
            ...localUserData?.journeyDetails,
            ...response?.journeyDetails
        }, planDetails: response?.planDetails ?? localUserData?.planDetails ?? null, metaDetails: response?.metaDetails ?? localUserData?.metaDetails ?? null };
        commonDispatch({
          type: 'UPDATE_USER',
          payload: {
            fullName: updatedUserData?.fullName || '',
            firstName: updatedUserData?.firstName || '',
            email: updatedUserData?.email || '',
            token: updatedUserData?.token || '',
            profileStatus: updatedUserData?.profileStatus || false,
            flipkartProfileStatus: updatedUserData?.flipkartProfileStatus || false,
            myntraProfileStatus: updatedUserData?.myntraProfileStatus || false,
            blinkitProfileStatus: updatedUserData?.blinkitProfileStatus || false,
            instamartProfileStatus: updatedUserData?.instamartProfileStatus || false,
            amcStatus: updatedUserData?.amcStatus || false,
            zeptoProfileStatus: updatedUserData?.zeptoProfileStatus || false,
            bigbasketProfileStatus: updatedUserData?.bigbasketProfileStatus || false,
            isWhatsappVerified: updatedUserData?.isWhatsappVerified || false,
          }
        })
        localStorage.setItem('User', JSON.stringify(updatedUserData));
      } 
    }).catch((err) => {
      // Ignore cancellation errors
      if (err && (err.name === 'CanceledError' || err.name === 'AbortError' || err.code === 'ERR_CANCELED')) {
        console.log('get-user-details request was cancelled');
        return;
      }
      // Log other errors but don't break the flow
      console.error('Error fetching user details:', err);
    }).finally(() => {
      // Only update loading state if request wasn't cancelled
      if (!abortController.signal.aborted) {
        setDoGetUserDetailLoading(false);
      }
    });

    // Cleanup function to cancel request when component unmounts or effect runs again
    return () => {
      if (getUserDetailsAbortControllerRef.current) {
        getUserDetailsAbortControllerRef.current.abort();
        getUserDetailsAbortControllerRef.current = null;
      }
    };
  }, [])

  useEffect(() => {

    const { loading: doGetFlipkartProfilesLoading } = doGetFlipkartProfiles
    const { loading: doGetMyntraProfilesLoading } = doGetMyntraProfiles
    const { loading: doGetBlinkitProfilesLoading } = doGetBlinkitProfiles
    const { loading: doGetProfilesLoading } = doGetProfiles
    const { loading: doGetInstamartProfilesLoading } = doGetInstamartProfiles
    const { loading: doGetZeptoProfilesLoading } = doGetZeptoProfiles
    const { loading: doGetBigbasketProfilesLoading } = doGetBigbasketProfiles

    const profileStoreKey = window.location.href.indexOf('/flipkart') > -1 ? 'flipkartProfile' : window.location.href.indexOf('/myntra') > -1 ? 'myntraProfile' : window.location.href.indexOf('/blinkit') > -1 ? 'blinkitProfile' : window.location.href.indexOf('/instamart') > -1 ? 'instamartProfile' : window.location.href.indexOf('/zepto') > -1 ? 'zeptoProfile' : window.location.href.indexOf('/bigbasket') > -1 ? 'bigbasketProfile' : 'selectedProfileId'
    const profileStoreData = JSON.parse(sessionStorage.getItem(profileStoreKey))
    console.log("profileStoreKey", profileStoreKey, profileStoreData)
    const processChecked =  profileStoreKey && profileStoreData && Object.keys(profileStoreData).length > 0 && (doGetFlipkartProfilesLoading && flipkartProfiles && flipkartProfiles?.length > 0) && (doGetMyntraProfilesLoading && myntraProfiles && myntraProfiles?.length > 0) && (doGetBlinkitProfilesLoading && blinkitProfiles && blinkitProfiles?.length > 0) && (doGetProfilesLoading && activeProfiles && activeProfiles?.length > 0 && profileStoreData?.dsp_only != true) && (doGetInstamartProfilesLoading && instamartProfiles && instamartProfiles?.length > 0) && (doGetZeptoProfilesLoading && zeptoProfiles && zeptoProfiles?.length > 0) && (doGetBigbasketProfilesLoading && bigbasketProfiles && bigbasketProfiles?.length > 0)
    
    // Refetch user details if a new plan has just been subscribed
    const isNewPlanSubscribed = Boolean(localStorage.getItem('NewPlanSubscribed') || false);

    if((processChecked == true && !doGetFlipkartProfilesLoading && !doGetMyntraProfilesLoading && !doGetBlinkitProfilesLoading && !doGetProfilesLoading && !doGetInstamartProfilesLoading && window.location.href.indexOf('expired') == -1 && !doGetZeptoProfilesLoading && !doGetBigbasketProfilesLoading) || isNewPlanSubscribed) {
      if(process.env.REACT_APP_BILLING_ENABLE == 1) {
        getCurrentPlanDetails.request({ url: '/subscription/get-current-plan-details', nodeAPI: 1 });
      }
      if(isNewPlanSubscribed) {
        localStorage.removeItem('NewPlanSubscribed');
      }
    }
    
  }, [doGetFlipkartProfiles.loading, flipkartProfiles, doGetMyntraProfiles.loading, myntraProfiles, doGetBlinkitProfiles.loading, blinkitProfiles, doGetProfiles.loading, activeProfiles, doGetInstamartProfiles.loading, instamartProfiles, doGetZeptoProfiles.loading, zeptoProfiles, doGetBigbasketProfiles.loading, bigbasketProfiles])  

  useEffect(() => {
    const { loading, data } = getDateAvailableParams
    console.log("getDateAvailableParams", data)
    if(!loading && data && data?.result && data?.result?.start_date && data?.result?.end_date && isDate(new Date(data?.result?.start_date)) && isDate(new Date(data?.result?.end_date))) {
      console.log("getParams", {...data.result})
      commonDispatch({ type: 'UPDATE_DATE_AVAILABLE', payload: {
        ...data.result,
        start_date: data?.result?.start_date + "T12:00:00Z",
        end_date: data?.result?.end_date + "T12:00:00Z",
      }})
    }
  }, [getDateAvailableParams.loading])

  useEffect(() => {
    const { loading, data } = getSqpDateAvailableParams
    if(!loading && data) {
      if(data?.result && data?.result?.start_date && data?.result?.end_date && isDate(new Date(data?.result?.start_date)) && isDate(new Date(data?.result?.end_date))) {
        commonDispatch({ type: 'UPDATE_DATE_AVAILABLE', payload: {
          ...data.result,
          sqp_start_date: data?.result?.start_date + "T12:00:00Z",
          sqp_end_date: data?.result?.end_date + "T12:00:00Z",
        }})
      } else {
        // Set the start date to be the 12th (noon) of the week 12 weeks before the last full week, 
        // and the end date as the last day (Sunday 12:00) of the last full week ending before the current end_date.

        // Get timezone from selectedProfileId in sessionStorage
        const selectedProfileId = JSON.parse(sessionStorage.getItem('selectedProfileId') || '{}');
        const profileTimezone = selectedProfileId?.timezone || 'Asia/Kolkata';

        // Helper function to get the last complete Saturday (end of last full week) in profile timezone
        // Weeks are Sun-Sat, so the end date should be Saturday
        // This function calculates based on TODAY in profile timezone
        function getLastFullWeekEnd(date) {
          // Always calculate from TODAY in profile timezone
          const nowInProfileTz = moment.tz(profileTimezone);
          
          // Get the day of week for TODAY (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
          const day = nowInProfileTz.day();
          
          let lastCompleteSaturday;
          if (day === 6) {
            // If today is Saturday, use today as the last complete Saturday
            // (Today's week is complete since we're at the end of the week)
            lastCompleteSaturday = nowInProfileTz.clone();
          } else {
            // For any other day, find the most recent Saturday
            // Subtract (day + 1) days to get to the previous Saturday
            lastCompleteSaturday = nowInProfileTz.clone().subtract(day + 1, 'days');
          }
          
          // Get date components to create a clean Date object in profile timezone
          const saturdayDateString = lastCompleteSaturday.format('YYYY-MM-DD');
          const [year, month, dayOfMonth] = saturdayDateString.split('-').map(Number);
          
          // Create a new moment in profile timezone with the date components
          const saturdayInTz = moment.tz({
            year: year,
            month: month - 1, // moment months are 0-indexed
            day: dayOfMonth,
            hour: 12,
            minute: 0,
            second: 0
          }, profileTimezone);
          
          // If we have an API date, use the minimum of API date or calculated Saturday
          if (date) {
            const apiDateInTz = moment.utc(date).tz(profileTimezone);
            const apiSaturdayInTz = apiDateInTz.clone().day(6); // Get Saturday of that week
            const apiSaturdayString = apiSaturdayInTz.format('YYYY-MM-DD');
            const [apiYear, apiMonth, apiDayOfMonth] = apiSaturdayString.split('-').map(Number);
            const apiSaturday = moment.tz({
              year: apiYear,
              month: apiMonth - 1,
              day: apiDayOfMonth,
              hour: 12,
              minute: 0,
              second: 0
            }, profileTimezone);
            
            // Use the minimum (earlier date) - this ensures we don't show future dates
            if (apiSaturday.isBefore(saturdayInTz, 'day')) {
              console.log("UPDATE_DATE_AVAILABLE < getLastFullWeekEnd - Using API date (earlier):", apiSaturday.format('YYYY-MM-DD HH:mm:ss z'));
              return apiSaturday.toDate();
            }
          }
          
          // Debug logging
          console.log("UPDATE_DATE_AVAILABLE < getLastFullWeekEnd - Now (Profile TZ):", nowInProfileTz.format('YYYY-MM-DD HH:mm:ss z'));
          console.log("UPDATE_DATE_AVAILABLE < getLastFullWeekEnd - Day of week:", day);
          console.log("UPDATE_DATE_AVAILABLE < getLastFullWeekEnd - Calculated Saturday (Profile TZ):", saturdayInTz.format('YYYY-MM-DD HH:mm:ss z'));
          
          // Return as Date object
          return saturdayInTz.toDate();
        }

        // Helper function to get the Sunday of the week 12 weeks before in profile timezone
        // Weeks are Sun-Sat, so the start date should be Sunday
        function getStartOf12thWeekBefore(endOfWeek) {
          // Convert endOfWeek to moment in profile timezone
          const endOfWeekInTz = moment(endOfWeek).tz(profileTimezone);
          // Go back 11 additional weeks (since the 12th week includes this one)
          const twelveWeeksBefore = endOfWeekInTz.clone().subtract(11, 'weeks');
          // Get the day of week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
          const day = twelveWeeksBefore.day();
          // Calculate difference to Sunday (week starts on Sunday)
          const diffToSunday = day === 0 ? 0 : -day;
          // Go to Sunday
          const sunday = twelveWeeksBefore.clone().add(diffToSunday, 'days');
          // Set to 12:00 in profile timezone
          sunday.hour(12).minute(0).second(0).millisecond(0);
          // Return as Date object
          return sunday.toDate();
        }

        // Get reference end date - use API date if available, otherwise use current date in profile timezone
        let referenceEndDate;
        if (getSqpDateAvailableParams?.data?.result?.end_date) {
          referenceEndDate = new Date(getSqpDateAvailableParams.data.result.end_date);
        } else {
          // Get current date directly in profile timezone (don't convert to Date first)
          // This ensures we're working with the correct date in the profile timezone
          const nowInProfileTz = moment.tz(profileTimezone);
          // Get date components to create a Date object that represents today in profile timezone
          const todayString = nowInProfileTz.format('YYYY-MM-DD');
          const [year, month, day] = todayString.split('-').map(Number);
          referenceEndDate = moment.tz({
            year: year,
            month: month - 1,
            day: day,
            hour: 12,
            minute: 0,
            second: 0
          }, profileTimezone).toDate();
        }

        console.log("UPDATE_DATE_AVAILABLE < referenceEndDate (Profile TZ):", moment(referenceEndDate).tz(profileTimezone).format('YYYY-MM-DD HH:mm:ss z'));
        
        const lastFullWeekEnd = getLastFullWeekEnd(referenceEndDate);
        const twelfthWeekStart = getStartOf12thWeekBefore(lastFullWeekEnd);

        // Convert dates back to profile timezone for proper formatting
        // This ensures dates represent the correct day in profile timezone
        const twelfthWeekStartInTz = moment(twelfthWeekStart).tz(profileTimezone);
        const lastFullWeekEndInTz = moment(lastFullWeekEnd).tz(profileTimezone);
        
        // Format dates in profile timezone for logging (for debugging)
        console.log("UPDATE_DATE_AVAILABLE < Profile Timezone:", profileTimezone);
        console.log("UPDATE_DATE_AVAILABLE < twelfthWeekStart (Profile TZ):", twelfthWeekStartInTz.format('YYYY-MM-DD HH:mm:ss z'));
        console.log("UPDATE_DATE_AVAILABLE < lastFullWeekEnd (Profile TZ):", lastFullWeekEndInTz.format('YYYY-MM-DD HH:mm:ss z'));

        // Store dates as ISO strings (UTC) - this is correct for storage
        // The dates are calculated in profile timezone, then converted to UTC for storage
        commonDispatch({
          type: 'UPDATE_DATE_AVAILABLE',
          payload: {
            sqp_start_date: twelfthWeekStart.toISOString(),
            sqp_end_date: lastFullWeekEnd.toISOString()
          }
        });
      }
      
    }
  }, [getSqpDateAvailableParams.loading])

  useEffect(() => {
    if(!doGetFlipkartProfiles.loading && !doGetMyntraProfiles.loading && !doGetBlinkitProfiles.loading && !doGetProfiles.loading && !doGetInstamartProfiles.loading && window.location.href.indexOf('account-settings') == -1 && window.location.href.indexOf('expired') == -1 && !doGetZeptoProfiles.loading && !doGetBigbasketProfiles.loading) {
      if (flipkartProfiles && flipkartProfiles?.length > 0 && window.location.href.indexOf('/flipkart') > -1) {
          const getFlipkartProfile = JSON.parse(sessionStorage.getItem('flipkartProfile'))
          if (getFlipkartProfile?.Value) {
            const url = isFlipkart && profileDictionary?.V2 === true
              ? `/flipkart-v2/check-client?client=${getFlipkartProfile?.Value}`
              : `/flipkart/check-client?client=${getFlipkartProfile?.Value}`;
              
            getDateAvailableParams.request({ url, nodeAPI: 1 });
          }
      } else if(instamartProfiles && instamartProfiles?.length > 0 && window.location.href.indexOf('/instamart') > -1) {
        const getInstamartProfile = JSON.parse(sessionStorage.getItem('instamartProfile'))
        if(getInstamartProfile?.Value) {
          getDateAvailableParams.request({ url: `/instamart/check-client?client=${String(getInstamartProfile?.Value)}`, nodeAPI: 1 });
        }
      } else if (myntraProfiles && myntraProfiles?.length > 0 && window.location.href.indexOf('/myntra') > -1) {
        const getMyntraProfile = JSON.parse(sessionStorage.getItem('myntraProfile'))
        if(getMyntraProfile?.Value) {
          getDateAvailableParams.request({ url: `/myntra/check-client?client=${String(getMyntraProfile?.Value)}`, nodeAPI: 1 });
        }
      } else if (blinkitProfiles && blinkitProfiles?.length > 0 && window.location.href.indexOf('/blinkit') > -1) {
        const getBlinkitProfile = JSON.parse(sessionStorage.getItem('blinkitProfile'))
        if(getBlinkitProfile?.Value) {
          getDateAvailableParams.request({ url: `/blinkit/check-client?client=${String(getBlinkitProfile?.Value)}`, nodeAPI: 1 });
        }
      } else if(activeProfiles && activeProfiles?.length > 0) {
          const getAmazonProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'))
          const amazonDsp = window.location.href.indexOf('amazon-dsp') > -1 
          const isAmc = window.location.href.indexOf('amazon-audience-instance') > -1 || window.location.href.indexOf('amazon-audience-instance/create') > -1 || window.location.href.indexOf('/amazon-audience-instance-info') > -1 || window.location.href.indexOf('amazon-audience-report') > -1 || window.location.href.indexOf('amazon-create-audience') > -1 || window.location.href.indexOf('amazon-view-audience') > -1 || window.location.href.indexOf('amazon-first-party-data') > -1 || window.location.href.indexOf('amazon-insights') > -1
          const planSelection = window.location.href.indexOf('plan-selection') > -1
          if(getAmazonProfile?.datasetId && getAmazonProfile?.dsp_only != true && !amazonDsp && !planSelection && !isAmc) {
            if (window.location.href.indexOf('search-query-performance') > -1 ) {
              getSqpDateAvailableParams.request({ url: `/sqp/check-dataset?datasetId=${getAmazonProfile?.datasetId}`, payload: {}, nodeAPI: 1 });
            } else {
              getDateAvailableParams.request({ url: `/amazon/check-dataset?datasetId=${getAmazonProfile?.datasetId}`, payload: {}, nodeAPI: 1 });
            }
          }
      }  else if (zeptoProfiles && zeptoProfiles?.length > 0 && window.location.href.indexOf('/zepto') > -1) {
        const getZeptoProfile = JSON.parse(sessionStorage.getItem('zeptoProfile'))
        if(getZeptoProfile?.Value) {
          getDateAvailableParams.request({ url: `/zepto/check-client?client=${String(getZeptoProfile?.Value)}`, nodeAPI: 1 });
        }
      }  else if (bigbasketProfiles && bigbasketProfiles?.length > 0 && window.location.href.indexOf('/bigbasket') > -1) {
        const getBigbasketProfile = JSON.parse(sessionStorage.getItem('bigbasketProfile'))
        if(getBigbasketProfile?.Value) {
          getDateAvailableParams.request({ url: `/bigbasket/check-client?client=${String(getBigbasketProfile?.Value)}`, nodeAPI: 1 });
        }
      }
    }
  }, [doGetFlipkartProfiles.loading, doGetMyntraProfiles.loading, doGetProfiles.loading, flipkartProfiles, activeProfiles,doGetInstamartProfiles.loading, doGetZeptoProfiles.loading, doGetBigbasketProfiles.loading, zeptoProfiles, bigbasketProfiles, instamartProfiles, myntraProfiles, blinkitProfiles])

  useEffect(() => {
    const { loading, data } = getCurrentPlanDetails
    if (!loading && data && data.success == true && data.result && Object.keys(data.result).length > 0) {
      setCurrentPlan(data.result ? { ad_account_limit: 1, ...data.result } : {});
      billingDispatch({type: 'UPDATE_PLAN_INFO', payload: { ...data.result } })
      // setCookie('plan_info', data.result ? dataEncrypt({ ad_account_limit: 1, ...data.result }) : {});
    }
  }, [getCurrentPlanDetails.loading])

  useEffect(() => {
    if (queryParams && Object.keys(queryParams).length > 0) {
      console.log('AMS--adminLayout', { queryParams});
      if (isAMS === true) {
        console.log('AMS--admin', queryParams);
        AMSqueryParamsApi(queryParams.code);
      } else if (isSeller === true) {
        console.log('ASP--adminLayout', queryParams);
        doSellerQueryParamsRetrive(queryParams);
      }
    }
  }, []);

  const goToProfile = () => {
    history.push('/profile');
  };

  const goToAddProfile = (routepage) => {
    if (routepage === 'thankyou') {
      history.push('/thankyou');
    } else if (routepage === 'profile') {
      history.push('/profile');
    } else if (routepage == 'addprofile') {
      history.push('/add-profile');
    }
  };

  useEffect(() => {
    if (windowSize.width > 992 && windowSize.width <= 1024 && layout !== 'horizontal') {
      dispatch({ type: actionType.COLLAPSE_MENU });
    }
    if (layout === 'horizontal' && windowSize.width < 992) {
      dispatch({ type: actionType.CHANGE_LAYOUT, layout: 'vertical' });
    }
  }, [dispatch, layout, windowSize]);

  useEffect(() => {
    const { data, loading } = doAMSQueryParam;
    console.log('doAMSQueryParam--AdminLayout', data);

    if (!loading && data?.success === false) {
      sweetAlertHandler({ type: 'danger', text: data.message, showConfirmButton: true, action: goToProfile });
    } else if (!loading && data?.success === true && data.data && Array.isArray(data.data) && data.data.length > 0) {
      let localData = JSON.parse(localStorage.getItem('AMSselectedCountry'));
      localData['refresh_token'] = data?.data?.refresh_token;
      localStorage.setItem('AMSselectedCountry', JSON.stringify(localData));
      // AMSretriveToken();
      localData['profiles'] = data?.data;
      localStorage.setItem('AMSselectedCountry', JSON.stringify(localData));
      localStorage.setItem('AMSexistingProfiles', JSON.stringify([]));
      sweetAlertHandler({
        type: 'success',
        text: data.message ? data.message : 'AMS Authorization Successful',
        showConfirmButton: true,
        action: goToAddProfile('addprofile')
      });
    } else if (!loading && data?.success === true && data.data && Array.isArray(data.data) && data.data.length == 0) {
      sweetAlertHandler({ type: 'danger', text: "No Ad Account Profiles Fetched, Please try again with Correct credentials of Amazon", showConfirmButton: true, action: goToProfile });
    }
  }, [doAMSQueryParam.loading]);

  // Helper function to update storage for grouped account re-authorization
  const updateGroupedAccountStorage = async (selectedProfileIdRefresh, sessionSelectedProfileId) => {
    return new Promise((resolve) => {
      try {
        // Update amazonStore in localStorage
        const amazonStore = JSON.parse(localStorage.getItem('amazonStore') || '[]');
        const updatedAmazonStore = amazonStore.map((item) => {
          if (selectedProfileIdRefresh?.parent_profile_id === item?.profileId) {
            const updatedGroupedAccounts = (item.ams?.groupedAccounts || []).map((groupedAccount) => {
              if (groupedAccount?.profileId === selectedProfileIdRefresh?.profileId) {
                return {
                  ...groupedAccount,
                  ams: {
                    ...groupedAccount.ams,
                    accessRevoked: false
                  }
                };
              }
              return groupedAccount;
            });
            
            return {
              ...item,
              ams: {
                ...item.ams,
                groupedAccounts: updatedGroupedAccounts
              }
            };
          }
          return item;
        });
        
        localStorage.setItem('amazonStore', JSON.stringify(updatedAmazonStore));

        // Update selectedProfileId in sessionStorage if it matches
        if (sessionSelectedProfileId?.profileId === selectedProfileIdRefresh?.parent_profile_id) {
          const amsCopy = { ...sessionSelectedProfileId?.ams };
          const updatedGroupedAccounts = (amsCopy?.groupedAccounts || []).map((groupedAccount) => {
            if (groupedAccount?.profileId === selectedProfileIdRefresh?.profileId) {
              return {
                ...groupedAccount,
                ams: {
                  ...groupedAccount.ams,
                  accessRevoked: false
                }
              };
            }
            return groupedAccount;
          });

          sessionStorage.setItem('selectedProfileId', JSON.stringify({
            ...sessionSelectedProfileId,
            ams: {
              ...amsCopy,
              groupedAccounts: updatedGroupedAccounts
            }
          }));
        }
        
        resolve();
      } catch (error) {
        console.error('Error updating grouped account storage:', error);
        resolve(); // Continue even if there's an error
      }
    });
  };

  // Helper function to update storage for main profile re-authorization
  const updateMainProfileStorage = async (selectedProfileIdRefresh, sessionSelectedProfileId) => {
    return new Promise((resolve) => {
      try {
        // Update amazonStore in localStorage
        const amazonStore = JSON.parse(localStorage.getItem('amazonStore') || '[]');
        const updatedAmazonStore = amazonStore.map((item) => {
          if (selectedProfileIdRefresh?.profileId === item?.profileId) {
            return {
              ...item,
              ams: {
                ...item.ams,
                accessRevoked: false
              }
            };
          }
          return item;
        });
        
        localStorage.setItem('amazonStore', JSON.stringify(updatedAmazonStore));

        // Update selectedProfileId in sessionStorage if it matches
        if (sessionSelectedProfileId?.profileId === selectedProfileIdRefresh?.profileId) {
          sessionStorage.setItem('selectedProfileId', JSON.stringify({
            ...sessionSelectedProfileId,
            ams: {
              ...sessionSelectedProfileId.ams,
              accessRevoked: false
            }
          }));
        }
        
        resolve();
      } catch (error) {
        console.error('Error updating main profile storage:', error);
        resolve(); // Continue even if there's an error
      }
    });
  };

  // Helper function to get profile name from selectedProfileIdRefresh
  const getProfileName = (selectedProfileIdRefresh) => {
    return selectedProfileIdRefresh?.accountInfo?.name || 
           selectedProfileIdRefresh?.accountInfo?.sortName || 
           selectedProfileIdRefresh?.name || 
           '';
  };

  useEffect(() => {
    const { data, loading } = doAmsReAuthorize;
    if (!loading && data?.success === true) {
      const handleSuccess = async () => {
        try {
          const selectedProfileIdRefresh = JSON.parse(localStorage.getItem('selectProfileIdRefresh') || '{}');
          const sessionSelectedProfileId = JSON.parse(sessionStorage.getItem('selectedProfileId') || '{}');
          
          // Get and store profile name
          const profileName = getProfileName(selectedProfileIdRefresh);
          localStorage.setItem('amsReauthProfileName', profileName);

          // Update storage based on whether it's a grouped account or main profile
          if (selectedProfileIdRefresh?.parent_profile_id) {
            await updateGroupedAccountStorage(selectedProfileIdRefresh, sessionSelectedProfileId);
          } else {
            await updateMainProfileStorage(selectedProfileIdRefresh, sessionSelectedProfileId);
          }

          // Clean up and navigate
          localStorage.removeItem('selectProfileIdRefresh');
          history.push('/admin/re-auth/success');
        } catch (error) {
          console.error('Error handling re-authorization success:', error);
          // Still navigate even if there's an error
          localStorage.removeItem('selectProfileIdRefresh');
          history.push('/admin/re-auth/success');
        }
      };

      handleSuccess();
    } else if (!loading && data?.success === false) {
      const handleFailure = () => {
        try {
          const selectedProfileIdRefresh = JSON.parse(localStorage.getItem('selectProfileIdRefresh') || '{}');
          const profileName = getProfileName(selectedProfileIdRefresh);
          
          localStorage.setItem('amsReauthProfileName', profileName);
          localStorage.setItem('amsReauthErrorMessage', data.message || '');
          localStorage.removeItem('selectProfileIdRefresh');
          history.push('/admin/re-auth/failed');
        } catch (error) {
          console.error('Error handling re-authorization failure:', error);
          localStorage.removeItem('selectProfileIdRefresh');
          history.push('/admin/re-auth/failed');
        }
      };

      handleFailure();
    }
  }, [doAmsReAuthorize.loading, history]);

  useEffect(() => {
    const { data, loading } = doAMSProfiles;
    console.log('doAMSProfiles--AdminLayout', data);
    if (!loading && data?.success === false) {
      sweetAlertHandler({ type: 'danger', text: data.message, showConfirmButton: true, action: goToProfile });
    } else if (!loading && data?.success === true && data.data.profiles) {
      let localData = JSON.parse(localStorage.getItem('AMSselectedCountry'));
      localData['profiles'] = data?.data?.profiles;
      localStorage.setItem('AMSselectedCountry', JSON.stringify(localData));
      localStorage.setItem(
        'AMSexistingProfiles',
        data?.data?.existing_profiles_ids ? JSON.stringify(data?.data?.existing_profiles_ids) : []
      );
      sweetAlertHandler({
        type: 'success',
        text: data.message ? data.message : 'AMS Authorization Successful',
        showConfirmButton: true,
        action: goToAddProfile('addprofile')
      });
    }
  }, [doAMSProfiles.loading]);

  useEffect(() => {
    const { data, loading } = doSellerQueryparam;
    const onboardingType = localStorage.getItem('onboarding');
    if (!loading && data?.success === false) {
      sweetAlertHandler({ type: 'danger', text: data.message, showConfirmButton: true, action: goToProfile });
    } else if (!loading && data?.success === true) {
      let localData = JSON.parse(sessionStorage.getItem('selectedProfileIdCopy'));
      if (localData) {
        if (onboardingType === 'seller') {
          localData.seller['connected'] = true;
        } else if (onboardingType === 'vendor') {
          localData['vendor'] = {
            connected: true
          };
        }
        sessionStorage.setItem('selectedProfileId', JSON.stringify(localData));
      }
      sweetAlertHandler({
        type: 'success',
        text: data.message ? data.message : `Amazon ${onboardingType === 'vendor' ? 'Vendor' : 'Seller'} Central Authorization Successful`,
        showConfirmButton: true,
        action: goToAddProfile('profile'),
      });
    }
  }, [doSellerQueryparam.loading]);

  useEffect(() => {
    const { data, loading } = doSellerProfiles;
    console.log('doSellerProfiles--AdminLayout', data);
    if (!loading && data?.success === false) {
      sweetAlertHandler({ type: 'danger', text: data.message, showConfirmButton: true, action: goToProfile });
    } else if (!loading && data?.success === true && data.data.profiles) {
      let localData = JSON.parse(localStorage.getItem('AMSselectedCountry'));
      localData['profiles'] = data.data.profiles;
      localStorage.setItem('AMSselectedCountry', JSON.stringify(localData));
      sweetAlertHandler({ type: 'success', text: data.message, showConfirmButton: true, action: goToProfile });
    }
  }, [doSellerProfiles.loading]);

  const AMSqueryParamsApi = (code) => {
    let ParseData = JSON.parse(localStorage.getItem('AMSselectedCountry'));
    const localUser = JSON.parse(localStorage.getItem('User'));
    const isAudience = localUser?.referalSource === 'amc' || localUser?.referalSource === 'dsp'
    const isDSPOnlyUserRegisteringAMC = ParseData?.dspOnly == true
    const selectedParentProfileId = JSON.parse(localStorage.getItem('selectedParentProfile'))
    const selectedProfileIdRefresh = JSON.parse(localStorage.getItem('selectProfileIdRefresh'))
    const groupConnection = selectedParentProfileId && Object.keys(selectedParentProfileId).length > 0
    if(selectedProfileIdRefresh && Object.keys(selectedProfileIdRefresh).length > 0 && selectedProfileIdRefresh?.re_authorize == true) {
      const isChild = 'parent_profile_id' in selectedProfileIdRefresh && selectedProfileIdRefresh?.parent_profile_id != null ? true : false;
      doAmsReAuthorize.request({
        url: '/aws/auth-refresh-callback',
        nodeAPI: 1,
        payload: {
          code: code,
          marketplace: selectedProfileIdRefresh?.marketplace,
          profileId: selectedProfileIdRefresh?.profileId,
          ...(isChild ? { parent_profile_id: selectedProfileIdRefresh?.parent_profile_id } : {}),
        }
      });
    } else if (ParseData && localUser) {
      doAMSQueryParam.request({
        url: isAudience || isDSPOnlyUserRegisteringAMC ? '/aws/auth-audience-callback' : groupConnection ? '/aws/auth-group-callback' : '/aws/auth-callback',
        nodeAPI: 1,
        payload: { 
          code: code, 
          marketplace: ParseData.region_name,
          ...(groupConnection ? { parent_profile_id: selectedParentProfileId?.profileId } : {}),
          ...(isAudience ? {
              referal: localUser?.referalSource || null,
              sales_person: localUser?.salesPerson || null
          } : {})
        }
      });
    }
  };

  const AMSretriveToken = () => {
    let ParseData = JSON.parse(localStorage.getItem('AMSselectedCountry'));
    const localUser = JSON.parse(localStorage.getItem('User'));
    if (ParseData && localUser) {
      console.log('parseData', ParseData);
      doAMSProfiles.request({
        url: '/ams-retrieve-profiles',
        payload: { token: localUser.token, refresh_token: ParseData.refresh_token, marketplace: ParseData.region_name }
      });
    }
  };

  const doSellerQueryParamsRetrive = (queryParams) => {
    const sellerData = JSON.parse(localStorage.getItem('ASPselectedCountry'));
    const vendorData = JSON.parse(localStorage.getItem('VendorSelectedCountry'));
    const localUser = JSON.parse(localStorage.getItem('User'));
    const onboardingType = localStorage.getItem('onboarding');
    const selectedParentProfileId = JSON.parse(localStorage.getItem('selectedParentProfile'))
    console.log('userFormAdmin', localUser);
    if (
      onboardingType === 'seller' &&
      sellerData &&
      localUser &&
      'ams_profile' in sellerData &&
      sellerData.ams_profile &&
      sellerData.ams_profile.profileId
    ) {
      if(selectedParentProfileId && Object.keys(selectedParentProfileId).length > 0) {
        doSellerQueryparam.request({
          url: '/aws/auth-group-seller-callback',
          nodeAPI: 1,
          payload: {
            grant_code: queryParams.spapi_oauth_code,
            marketplace: sellerData.region_code,
            profile_id: selectedParentProfileId.profileId,
            selling_partner_id: queryParams.selling_partner_id
          }
        });
      } else {
        doSellerQueryparam.request({
          url: '/aws/auth-seller-callback',
          nodeAPI: 1,
          payload: {
            grant_code: queryParams.spapi_oauth_code,
            marketplace: sellerData.region_code,
            profile_id: sellerData.ams_profile.profileId,
            selling_partner_id: queryParams.selling_partner_id
          }
        });
      } 
    } else if (
      onboardingType === 'vendor' &&
      vendorData &&
      localUser &&
      'ams_profile' in vendorData &&
      vendorData.ams_profile &&
      vendorData.ams_profile.profileId
    ) {
      if(selectedParentProfileId && Object.keys(selectedParentProfileId).length > 0) {
        doSellerQueryparam.request({
          url: '/aws/auth-group-vendor-callback',
          nodeAPI: 1,
          payload: {
            grant_code: queryParams.spapi_oauth_code,
            marketplace: vendorData.region_code,
            profile_id: selectedParentProfileId.profileId,
            selling_partner_id: queryParams.selling_partner_id
          }
        });
      } else {
        doSellerQueryparam.request({
          url: '/aws/auth-vendor-callback',
          nodeAPI: 1,
          payload: {
            grant_code: queryParams.spapi_oauth_code,
            marketplace: vendorData.region_code,
            profile_id: vendorData.ams_profile.profileId,
            selling_partner_id: queryParams.selling_partner_id
          }
        });  
      }
    }
  };

  const exitFullscreen = () => {
    document.exitFullscreen();
    document.addEventListener('fullscreenchange', (event) => {
      const element = document.getElementById('panel-wrapper');
      if (document.fullscreenElement) {
        element.classList.add('fscreen-enbld');
      } else {
        element.classList.remove('fscreen-enbld');
      }
    });
  };

  document.onkeydown = function (evt) {
    const element = document.getElementById('panel-wrapper');
    evt = evt || window.event;
    var isEscape = false;
    if ('key' in evt) {
      isEscape = evt.key === 'Escape' || evt.key === 'Esc';
    } else {
      isEscape = evt.keyCode === 27;
    }
    if (isEscape) {
      element.classList.remove('fscreen-enbld');
    }
  };

  console.log('doAMSQueryParam', doAMSQueryParam);
  const mobileOutClickHandler = () => {
    if (windowSize.width < 992 && collapseMenu) {
      dispatch({ type: actionType.COLLAPSE_MENU });
    }
  };

  let mainClass = ['pcoded-wrapper'];
  if (layout === 'horizontal' && subLayout === 'horizontal-2') {
    mainClass = [...mainClass, 'container'];
  }
  const noAccessCard = window.location.href.indexOf('/amazon/restricted') > -1
  const noAccessStyles = noAccessCard == true ? { minHeight: 'calc(100vh - 90px)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' } : {};

  const fscreenloader = () => {
    setScreenLoader(true);
  };

  const sweetAlertHandler = (alert) => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: alert.text,
      // text: alert.text,
      type: alert.type,
      timer: alert.timer,
      showConfirmButton: alert.showConfirmButton,
      didClose: alert.action
        ? alert.action
        : () => {
          console.log('Actioned');
        },
      allowOutsideClick: false
    });
  };

  // useEffect(() => {
  //   console.log('document?.fullscreen', document?.fullscreen);
  //   if (document?.fullscreen === true) {
  //     setexitOverlay(true);
  //   } else if (document?.fullscreen === true) {
  //     setexitOverlay(false);
  //   }

  //   return () => {
  //     setexitOverlay(false);
  //   };
  // }, [document?.fullscreen]);

  // useEffect(() => {
  //   console.log('document?.fullscreen', document?.fullscreen);
  //   if (document?.fullscreen === true) {
  //     setExitActive(false);
  //   } else if (document?.fullscreen === true) {
  //     setExitActive(false);
  //   }

  //   return () => {
  //     setExitActive(false);
  //   };
  // }, [document?.fullscreen]);

  const [isFullScreen, setIsFullScreen] = useState(false);

  const enableFullscreen = () => {
    const element = document.documentElement; // Fullscreen the entire document
    const DocElement = document.getElementById('panel-wrapper');
    if (!isFullScreen) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        // Firefox
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        // Chrome, Safari and Opera
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        // Internet Explorer/Edge
        element.msRequestFullscreen();
      }
      DocElement.classList.add('fscreen-enbld');
      document.body.classList.add('full-sceen-on');
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        // Chrome, Safari and Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // Internet Explorer/Edge
        document.msExitFullscreen();
      }
      DocElement.classList.remove('fscreen-enbld');
      document.body.classList.remove('full-sceen-on');
    }

    setIsFullScreen(!isFullScreen);
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      const DocElement = document.getElementById('panel-wrapper');
      console.log('document.fullscreenElement', document.fullscreenElement);
      if (document.fullscreenElement == null) {
        DocElement.classList.remove('fscreen-enbld');
        document.body.classList.remove('full-sceen-on');
      }
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, []);

  const isLayoutLoaded = useMemo(() => {
    return (
      (
        // If on Amazon and profiles are loaded
        location.pathname.includes('amazon') &&
        !doGetProfiles.loading &&
        (amzState?.amazonProfiles?.length > 0 || location.pathname.includes('amazon-dsp-request') || location.pathname.includes('amazon-audience-instance/create'))
      ) ||
      (
        // If on Flipkart and profiles are loaded
        location.pathname.includes('flipkart') &&
        !doGetFlipkartProfiles.loading &&
        fkState?.flipkartProfiles?.length > 0
      ) ||
      (
        // If on Myntra and profiles are loaded
        location.pathname.includes('myntra') &&
        !doGetMyntraProfiles.loading &&
        myntraState?.myntraProfiles?.length > 0
      ) ||
      (
        // If on Blinkit and profiles are loaded
        location.pathname.includes('blinkit') &&
        !doGetBlinkitProfiles.loading &&
        blinkitState?.blinkitProfiles?.length > 0
      ) ||
      (
        // If on Instamart and profiles are loaded
        location.pathname.includes('instamart') &&
        !doGetInstamartProfiles.loading &&
        instamartState?.instamartProfiles?.length > 0
      ) ||
      (
        // If on Zepto and profiles are loaded
        location.pathname.includes('zepto') &&
        !doGetZeptoProfiles.loading &&
        zeptoState?.zeptoProfiles?.length > 0

      ) ||
      (
        // If on Bigbasket and profiles are loaded
        location.pathname.includes('bigbasket') &&
        !doGetBigbasketProfiles.loading &&
        bigbasketState?.bigbasketProfiles?.length > 0
      ) ||
      (
        // Fallback for cases where the URL does not match any platform
        !location.pathname.includes('amazon') &&
        !location.pathname.includes('flipkart') &&
        !location.pathname.includes('myntra') &&
        !location.pathname.includes('blinkit') &&
        !location.pathname.includes('instamart') &&
        !location.pathname.includes('zepto') &&
        !location.pathname.includes('bigbasket')
      ) 
    )
  }, [
    doGetProfiles.loading,
    amzState?.amazonProfiles,
    doGetFlipkartProfiles.loading,
    fkState?.flipkartProfiles,
    doGetMyntraProfiles.loading,
    myntraState?.myntraProfiles,
    doGetBlinkitProfiles.loading,
    blinkitState?.blinkitProfiles,
    doGetInstamartProfiles.loading,
    instamartState?.instamartProfiles,
    doGetZeptoProfiles.loading,
    zeptoState?.zeptoProfiles,
    doGetBigbasketProfiles.loading,
    bigbasketState?.bigbasketProfiles,
    location.pathname
  ])

  const[isPaymentAlertNotShow, setIsPaymentAlertNotShow] = useState(1)

  // const isPaymentAlert = currentPlan && ((currentPlan?.isTrail === 1 && isDate(new Date(currentPlan?.trialStartDate)) && isDate(new Date(currentPlan?.trialExpireDate)) && differenceInDays(new Date(currentPlan?.trialExpireDate), new Date()) < 8) || (currentPlan?.isTrail === 0 && currentPlan?.nextPayment && isDate(new Date(currentPlan?.nextPayment)) && differenceInDays(new Date(currentPlan?.nextPayment), new Date()) < 8)) && isPaymentAlertNotShow ? 1 : 0

  const isIncompatibleScreen = useMemo(() => {
    const pathname = location.pathname.toLowerCase();
    const isTargeting360 = pathname.includes('/amazon/targeting') 
    const isSnapshot = pathname.includes('snapshot');
    const isMasterOverview = pathname.includes('master-overview');
    
    return isTargeting360 || isSnapshot || isMasterOverview;
  }, [location.pathname]);

  const isMobileOrTablet = useMemo(() => {
    return windowSize.width && windowSize.width < 992;
  }, [windowSize.width]);

  let common = (
    <React.Fragment>
      {isPaymentAlert ? <div className="notify_top">
        <h2 className="f-474444 f-14 f-w-500 l-20 text-capitalize">
          {currentPlan?.message?.replace(', Upgrade now to start subscription', '.')?.replace('your trial period expired on in', 'Your Trial period will expire in')} <span className="f-5932EA f-14 f-w-600 cursor-pointer" onClick={() => {
            localStorage.setItem('isPlanUpdate', true);
            history.push('/plan-selection');
          }}>Upgrade now to start subscription</span>
        </h2>
        <p className='notify_clse' onClick={() => setIsPaymentAlertNotShow(0)}>&#x2715;</p>
      </div> : null}
      <Navigation IsFlipkartUser={process.env.REACT_APP_FLIPKART_ACCESS_EMAIL.indexOf(ParseData?.email) > -1} isTrail={isPaymentAlert === 1 ? true : false} />
    </React.Fragment>
  );

  let mainContainer = (
    <React.Fragment>
      <NavBar isTrail={isPaymentAlert === 1 ? true : false} activeProfiles={activeProfiles} isFullScreen={isFullScreen} enableFullscreen={enableFullscreen} listTotalCount={listTotalCount} />
      <div className={`pcoded-main-container ${zoom}`} id="panel-wrapper">
        {/* FULL SCREEN LOADER */}
        <section className="h-screen m-auto f-loader">
          <div>
            <img src={chartloader} alt="loader" className="mr-1 wid-80 hei-80" />
          </div>
        </section>
        {/* FULL SCREEN LOADER */}

        {/* EXIT FULL SCREEN BUTTON */}
        {isFullScreen && <div className="fsch-hover" onMouseEnter={() => setExitActive(true)} onMouseLeave={() => setExitActive(false)} />}
        {isFullScreen && isExit === true && (
          <div className="exit-btn hover-theme" onMouseEnter={() => setExitActive(true)}>
            {/* <DropdownButton className="text-capitalize txt-secondary" title="Targeting Summary" variant="white">
                      <Dropdown.Item eventKey="1" active>
                        <Link to="targeting-summary">Targeting Summary</Link>
                      </Dropdown.Item>
                      <Dropdown.Item eventKey="2">
                        <Link to="search-term">Search Term</Link>
                      </Dropdown.Item>
                      <Dropdown.Item eventKey="3">
                        <Link to="profile">Profile</Link>
                      </Dropdown.Item>
                      <Dropdown.Item eventKey="4">
                        <Link to="addaccount">Add Account</Link>
                      </Dropdown.Item>
                    </DropdownButton> */}
            <Minimize
              size={18}
              className="cursor-pointer hover-theme f-20 txt-secondary"
              onClick={() => {
                enableFullscreen();
                setexitOverlay(false);
                setExitActive(true);
              }}
            />
            {/* <Button name="Exit" classes="txt-secondary hover-theme" action={exitFullscreen} /> */}
          </div>
        )}
        {/* EXIT FULL SCREEN BUTTON */}
        <div className={mainClass.join(' ')}>
          <div className={`pcoded-content ${isPaymentAlert ? 'billing_notify' : ''}`}>
            <div className="pcoded-inner-content" style={noAccessStyles}>
              <Breadcrumb />
              {isMobileOrTablet && isIncompatibleScreen ? <MobileTabletIncompatible /> : children}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );

  if (windowSize.width < 992) {
    let outSideClass = ['nav-outside'];
    if (collapseMenu) {
      outSideClass = [...outSideClass, 'mob-backdrop'];
    }
    if (headerFixedLayout) {
      outSideClass = [...outSideClass, 'mob-fixed'];
    }

    common = (
      <div className={outSideClass.join(' ')} ref={ref}>
        {common}
      </div>
    );

    mainContainer = (
      <div className="pcoded-outside" onClick={() => mobileOutClickHandler}>
        {mainContainer}
      </div>
    );
  }

  if (doAMSQueryParam.loading || doAMSProfiles.loading || doSellerQueryparam.loading || doAmsReAuthorize.loading) {
    return (
      <section className="h-screen d-flex flex-column align-items-center justify-content-center">
        <img src={MainLogo} alt="hector" className="mb-4 hei-55 d-none d-lg-block" />
        <div class="fastforward mb-3">
          <section className="connect-logo">
            <img src={AmazonLogo} className="wid-45" alt="amazon" />
          </section>

          <section className="d-flex flex-column align-items-center justify-content-center">
            <p className="mb-4 f-333843 f-16 f-w-600 text-center">Authorization in progress...</p>
            <div className="load-wrapp">
              <div className="load-10">
                <div className="bar"></div>
              </div>
            </div>
          </section>

          <section className="connect-logo">
            <img src={Logo} className="wid-45" alt="logo" />
          </section>
        </div>
      </section>
    );
  }
  // else if (doAMSProfiles.loading) {
  //   return (
  //     <section className="h-screen d-flex flex-column align-items-center justify-content-center">
  //       <div className="fastforward mb-3">
  //         <section className="connect-logo">
  //           <img src={AmazonLogo} className="wid-50" />
  //         </section>

  //         <div className="load-wrapp">
  //           <div className="load-10">
  //             <div className="bar"></div>
  //           </div>
  //         </div>

  //         <section className="connect-logo">
  //           <img src={Logo} className="wid-50" />
  //         </section>

  //       </div>
  //         <p>Authorization on progress ...</p>
  //     </section>
  //   );
  // }
  // else if (doSellerQueryparam.loading) {
  //   return (
  //     <section className="h-screen d-flex flex-column align-items-center justify-content-center">
  //       <div className="fastforward mb-3">
  //         <section className="connect-logo">
  //           <img src={AmazonLogo} className="wid-50" />
  //         </section>

  //         <div className="load-wrapp">
  //           <div className="load-10">
  //             <div className="bar"></div>
  //           </div>
  //         </div>

  //         <section className="connect-logo">
  //           <img src={Logo} className="wid-50" />
  //         </section>

  //       </div>
  //         <p>Getting Seller Refresh Token</p>
  //     </section>
  //   );
  // }
  // !doGetUserDetailLoading &&

  if (
    isAppReady && // Check if the app is ready
    isLayoutLoaded
  ) return (
      <React.Fragment>
        {common}
        {mainContainer}
        {configBlock}
        {/* {isSuperAdmin && <SupportIntercom 
          doGetUserDetails={doGetUserDetails}
          isAppReady={isAppReady}
          doGetProfiles={doGetProfiles}
          amzState={amzState}
          doGetFlipkartProfiles={doGetFlipkartProfiles}
          fkState={fkState}
          doGetMyntraProfiles={doGetMyntraProfiles}
          myntraState={myntraState}
          doGetBlinkitProfiles={doGetBlinkitProfiles}
          blinkitState={blinkitState}
          doGetInstamartProfiles={doGetInstamartProfiles}
          instamartState={instamartState}
          doGetZeptoProfiles={doGetZeptoProfiles}
          zeptoState={zeptoState}
          doGetBigbasketProfiles={doGetBigbasketProfiles}
          bigbasketState={bigbasketState}
         />} */}
        {commonState?.overlay?.modal?.show === true ? <div className={`${commonState?.overlay?.modal?.classes ? commonState?.overlay?.modal?.classes : 'position-fixed inset-0 z-1500 cusor-pointer'}`} onClick={() => {
          commonState?.overlay?.modal?.closeCallBack()
        }}></div> : null}
        {location.pathname.includes('amazon/targeting') && <BCGTextualAlert />}
        <Footer />
      </React.Fragment>
    );
  return (
    <React.Fragment>
      <ThemeProvider>
        {/* {String(isAppReady)} */}
        <section className="h-screen d-flex align-items-center justify-content-center f-18 f-w-500 text-dark bg-white">
          <img src={ConnectingLoader} alt="Connect" className="wid-40" />
          <StyleTag />
        </section>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default AdminLayout;

export const CurrencyCodeMarketPlace = {
  "USD": "north_america",
  "AUD": "east",
  "SAR": "europe",
  "SEK": "europe",
  "BRL": "north_america",
  "GBP": "europe",
  "EUR": "europe",
  "PLN": "europe",
  "INR": "europe",
  "MXN": "north_america",
  "CAD": "north_america",
  "AED": "europe"
}

